<template lang="pug">
div.min-height-300
  b-table(
    :items="currentTableItems"
    :fields="visibleColumns"
    head-row-variant="light-primary"
    tbody-class="tabla-tbody"
    thead-class="text-black tabla-thead"
    tbody-tr-class="bg-white"
    responsive
    :busy="isBusy"
    :show-empty="shouldShowEmpty"
    empty-text="No hay Ordenes de Trabajo en este estado"
    no-local-sorting
    @head-clicked="onHeaderClicked"
    :sort-by="sortBy"
    :sort-desc="sortDesc"
    sort-icon-left
    primary-key="ot.ot"
  )
    template(#table-busy)
      .loader-container
        Loader

    template(#cell(ot)='{value}')
      .ot-cell
        router-link(
          :to="(isRetailUser ? 'cliente' : 'orden') + `/${value.ot}` + (isRetailUser ? `/rut/${getClientRut(value.cliente)}` : '')"
          :style="getColorOT(value)"
        ) {{value.ot}}
        CircularIcon(
          :number="value.segundos_ingresos ? value.segundos_ingresos.length : 0"
          classCustom="circular-icon"
          v-b-popover.hover.html="getSecondEnterData(value.segundos_ingresos)" title="Otros ingresos")
        CircularIcon(
          v-if="value.cambio_3x3"
          number="3x3"
          classCustom="circular-icon circular-icon-3x3")

    template(#cell(serie)='{ item, value }')
      .d-flex.flex-row.align-items-start
        div(v-if="item.ot.alert_text" v-b-tooltip.hover :title="item.ot.alert_text")
          b-icon.mr-2.cursor-pointer(
            icon="exclamation-triangle" variant="warning" font-scale="1.5"
            @click="showSerialNumberAlertModal(item.ot)"
          )
        span {{ value }}

    template(#cell(rma)='{ item, value }')
      div
        span {{ value }}
        small.d-block.text-muted(v-if="isRetailUser && item.ot.guia_despacho_ingreso") Guía: {{ item.ot.guia_despacho_ingreso }}

    template(#cell(despacho)='{value}')
      //- span {{ LABEL_TIPO_DESPACHO(value) }}
      span {{ value }}

    template(#cell(informe)='{ item }')
      div
        a.btn.btn-sm.btn-outline-primary.mr-1(
          v-if="item.ot.informe_cliente_pdf"
          :href="backUrl + item.ot.informe_cliente_pdf"
          target="_blank"
        ) Informe de Rep
        a.btn.btn-sm.btn-outline-primary(
          v-if="item.ot.cambio_3x3 && item.ot.pdf_cambio"
          :href="backUrl + item.ot.pdf_cambio"
          target="_blank"
        ) Certificado de cambio
        span(v-if="!item.ot.informe_cliente_pdf && !(item.ot.cambio_3x3 && item.ot.pdf_cambio)") —

    template(#cell(estado)='{ item, value }')
      div(
        @mouseenter="onEstadoHovered(item)"
        style="cursor: pointer;"
        v-b-tooltip.hover.html.right="getPartesTooltip(item)"
        :title="getPartesTooltip(item)"
      )
        Status(:status="getEstadoForRetail(item, value)")
        b-badge.mt-1(
          v-if="item.ot.prioridad_asignacion"
          variant="warning"
        ) Prioridad de asignación

    template(#cell(all_time)="value")
      .d-flex.flex-row
      | {{totalTime(value).time}}

    template(#cell(state_time)="value")
      b-icon.mr-1( :icon="value && currentStatusTime(value).icon" :variant="value && currentStatusTime(value).variant")
      | {{currentStatusTime(value).time}}
      //- span {{ value.item.ot.detalle_tiempos.state }}

    template(#cell(excepciones)='value')
      router-link(v-if="value.item.excepciones" :to="`orden/${value.item.ot.ot}?from=excepciones`") {{value.item.excepciones.count}}

    template(#cell(acciones)="{ item, index }")
      div(v-if="item.ot.loadingActions"  class="d-flex justify-content-center align-items-center")
        b-spinner(small)
      template(v-else)
        ActionsWrapper(
          :ref="`actionsWrapper${index}`"
          :otId="item.ot.ot"
          :rma="item.ot.rma"
          :actions="item.accionesDisponibles || { visible: [], disabled: [], secondary: [], has_active_actions: false }"
          :is-not-closed="item.ot.estado && item.ot.estado.estado.nombre !== 'Cerrado'"
          @changed="() => $emit('changed')"
          :parentLoading="loading"
          @refresh-ot="() => $emit('refresh-single-ot', item.ot.ot)"
        )
  SerialNumberAlertModal(
    v-model="serialNumberAlertModal"
    @close="serialNumberAlertOT = null"
    :ot="serialNumberAlertOT"
  )
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import formatElapsedTime, {
  formatElapsedTimeInHours,
} from '@/utils/formatElapsedTime'
import secondsToHoursMinutes from '@/utils/secondsToHoursMinutes'
import SerialNumberAlertModal from '@/components/OT/SerialNumberAlertModal.vue'
import { backUrl } from '../../../../settings'
import CircularIcon from '../../UI/CircularIcon.vue'
import Status from '../Status.vue'
import ActionsWrapper from './ActionsWrapper.vue'
import Loader from '../../UI/Loader.vue'

/** Recibe un listado de OTs y la renderea en una tabla */
export default {
  name: 'OtTable',
  props: [
    'otItems',
    'loading',
    'loadingTabs',
    'titleTabSelected',
    'sortBy',
    'sortDesc',
  ],
  components: {
    CircularIcon,
    Status,
    ActionsWrapper,
    SerialNumberAlertModal,
    Loader,
  },
  data() {
    return {
      backUrl,
      firstLoad: true,
      fields: [
        { key: 'ot', label: 'O.T', stickyColumn: true, sortable: true },
        { key: 'fecha_ingreso', label: 'Fecha', sortable: true },
        {
          key: 'tipo_servicio',
          label: 'Tipo',
          sortable: true,
          condition: () => !this.isRetailUser,
        },
        { key: 'rma', sortable: true },
        { key: 'cliente', sortable: true },
        { key: 'serie', sortable: true },
        { key: 'tecnico', sortable: true, condition: () => !this.isRetailUser },
        {
          key: 'ubicacion',
          sortable: true,
          condition: () => !this.isRetailUser,
        },
        {
          key: 'despacho',
          sortable: true,
          condition: () => !this.isRetailUser,
        },
        {
          key: 'estado',
          label: 'Estado',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'state_time',
          label: 'Tiempo Estado',
          sortable: true,
          condition: () => !this.isRetailUser,
        },
        { key: 'all_time', label: 'Tiempo Total', sortable: true },
        {
          key: 'codigo_retail',
          label: 'Código Retail',
          sortable: true,
          condition: () => this.isRetailUser,
        },
        {
          key: 'guia_despacho_ingreso',
          label: 'Guía Despacho Ingreso',
          sortable: true,
          condition: () => this.isRetailUser,
        },
        {
          key: 'sucursal',
          label: 'Sucursal',
          sortable: true,
          condition: () => this.isRetailUser,
        },
        {
          key: 'informe',
          label: 'Informe',
          condition: () => this.isRetailUser,
        },
        {
          key: 'acciones',
          label: 'Acciones',
          condition: () => !this.isRetailUser,
        },
      ],
      // Internal sort state (for syncing)
      internalSortBy: null,
      internalSortDesc: false,
      serialNumberAlertOT: null,
      serialNumberAlertModal: false,
      loadingActions: false,
      controller: null,
      partesData: {},
    }
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
    ...mapGetters('OT', [
      'isInitialDataState',
      'isSearching',
      'loadingInputSearch',
    ]),
    isRetailUser() {
      return this.user?.user?.groups?.some((g) => g.name === 'Retail')
    },

    visibleColumns() {
      return this.fields.filter((f) => (f.condition ? f.condition() : true))
    },

    /** Transforma las ot en formato requerido para tabla bootstrap */
    currentTableItems() {
      if (!this.otItems || !this.otItems.results) return []
      return this.otItems.results.map((O) => ({
        ot: O,
        fecha_ingreso: O.fecha_ingreso
          ? moment(O.fecha_ingreso).format('DD/MM/YYYY')
          : '-',
        tipo_servicio: O.tipo_servicio ? O.tipo_servicio : '-',
        rma: O.rma ? O.rma : '-',
        serie:
          O.equipo && O.equipo.serial_number ? O.equipo.serial_number : '-',
        ubicacion: O.ubicacion ? O.ubicacion : '-',
        tecnico: O.tecnico_asignado
          ? `${O.tecnico_asignado.first_name} ${O.tecnico_asignado.last_name}`
          : '-',
        despacho: O.despacho,
        estado: O.estado ? O.estado : 'Sin estado',
        limite_total_rojo: O.limite_total_rojo,
        limite_total_amarillo: O.limite_total_amarillo,
        all_time: O.tiempo_estados?.hora_total,
        state_time: O.tiempo_estados?.hora_estado_actual,
        cliente: this.getClient(O.cliente),
        ingreso: this.getDate(O.fecha_ingreso),
        tipo: O.equipo
          ? O.equipo.modelo_detail.tipo_dispositivo
            ? O.equipo.modelo_detail.tipo_dispositivo.nombre
            : '-'
          : '-',
        marca: O.equipo ? O.equipo.modelo_detail.marca.marca_name : '-',
        serial_number: O.equipo ? O.equipo.serial_number : '-',
        falla: O.reporte_falla_cliente,
        recepcionista: O.recepcionista_detail
          ? `${O.recepcionista_detail.first_name} ${O.recepcionista_detail.last_name}`
          : '-',
        selectTechnician: O,
        codigo_retail: O.codigo_retail,
        guia_despacho_ingreso: O.guia_despacho_ingreso,
        sucursal: O.sucursal_nombre || '-',
        detalle_tiempo_compuesto: O.detalle_tiempo_compuesto,
        tiempo_estados: O.tiempo_estados,
      }))
    },
    // Centraliza cuándo la tabla debe mostrarse en busy
    isBusy() {
      // Mantener busy hasta que el padre marque la data como resuelta
      if (!this.otItems || this.otItems.loaded !== true) return true
      if (this.loading) return true
      if (this.isSearching) return true
      if (this.loadingInputSearch) return true
      if (
        this.loadingTabs &&
        this.isInitialDataState &&
        this.titleTabSelected
      ) {
        return !!this.loadingTabs[this.titleTabSelected]
      }
      return false
    },
    shouldShowEmpty() {
      // No mostrar mensaje vacío mientras la tabla está ocupada (cargando)
      if (this.isBusy) {
        return false
      }
      // Mostrar mensaje vacío solo cuando realmente no hay items
      return this.currentTableItems.length === 0
    },
  },
  methods: {
    ...mapActions('OT', ['getActionsOT', 'getPartesOT']),
    getClientRut(cliente) {
      if (cliente.persona && cliente.tipo_cliente === 'Persona') {
        return cliente.persona.rut
      }
      if (cliente.empresa && cliente.tipo_cliente === 'Empresa') {
        return cliente.empresa.rut
      }
      return ''
    },
    sortingChanged(context) {
      this.$emit('sortingChanged', context.sortBy, context.sortDesc)
    },
    onHeaderClicked(key) {
      // Only handle sortable fields
      const field = this.fields.find((f) => f.key === key)
      if (!field || !field.sortable) return

      let newSortBy = key
      let newSortDesc = false

      // Toggle sort direction using internal state
      if (this.internalSortBy === key) {
        newSortDesc = !this.internalSortDesc
      } else {
        newSortBy = key
        newSortDesc = false
      }

      // Sync internal state immediately for smooth UI
      this.internalSortBy = newSortBy
      this.internalSortDesc = newSortDesc

      // Emit sorting event to parent (GenericOTList)
      this.$emit('sortingChanged', newSortBy, newSortDesc)
    },
    getColorOT(value) {
      let style = 'color:#41509B; font-weight: bold'
      if (value.estado) {
        const state = value.estado.estado.nombre
        if (state === 'En Solicitud de Excepción') {
          style = 'color:#7F828F; font-weight: bold'
        }
      }
      return style
    },
    getClient(cliente) {
      if (!cliente) return '-'
      if (cliente.persona && cliente.tipo_cliente === 'Persona') {
        return `${cliente.persona.nombre} ${cliente.persona.apellido}`
      }
      return `${cliente.empresa ? cliente.empresa.razon_social : ''}`
    },
    getDate(date) {
      if (date) {
        const formatedDate = moment(date).format('DD/MM/YYYY')
        return formatedDate
      }
      return '-'
    },
    getSecondEnterData(ordenes) {
      const urls = []
      if (Array.isArray(ordenes)) {
        // eslint-disable-next-line
        ordenes.map((o) => {
          const rmaValue = o.rma ? ` | ${o.rma}` : ''
          urls.push(
            `<a href="/orden/${
              o.ot
            }" target="_blank" class="related-ot-link"> ${o.ot}</a> (${moment(
              o.fecha_ingreso
            ).format('DD-MM-YYYY')}${rmaValue})<br>`
          )
        })
        return urls.join('')
      }
      return `<a href="/orden/${ordenes}" target="_blank" class="related-ot-link"> ${ordenes} </a>`
    },
    getAllTime(value) {
      const OT = value.item
      return secondsToHoursMinutes(OT.all_time)
    },
    currentStatusTime(value) {
      const ot = value.item
      const time =
        ot?.tiempo_estados?.hora_compuesta_actual ||
        ot?.tiempo_estados?.hora_estado_actual
      if (!time) return { time: '00:00' }

      const hora_alerta_1 =
        ot?.detalle_tiempo_compuesto?.estado_compuesto?.hora_alerta_1 ||
        ot.estado.estado?.hora_alerta_1
      const hora_alerta_2 =
        ot?.detalle_tiempo_compuesto?.estado_compuesto?.hora_alerta_2 ||
        ot.estado.estado?.hora_alerta_2
      const alerta1 = hora_alerta_1 * 3600 || 0
      const alerta2 = hora_alerta_2 * 3600 || 100000

      let data
      if (time < alerta1) {
        data = { icon: 'check-circle', variant: 'estado-green' }
      } else if (time >= alerta1 && time < alerta2) {
        data = { icon: 'exclamation-circle-fill', variant: 'estado-yellow' }
      } else if (time >= alerta2) {
        data = { icon: 'exclamation-triangle-fill', variant: 'estado-red' }
      }

      return { ...data, time: formatElapsedTimeInHours(time, false) || '' }
    },
    totalTime(value) {
      const ot = value.item
      const time = ot.all_time
      if (!time) return { time: '---' }
      const hours = Math.round(time / 3600)
      const alerta1 = ot.limite_total_amarillo
      const alerta2 = ot.limite_total_rojo
      let data

      if (hours < alerta1) {
        data = { icon: 'check-circle', variant: 'estado-green' }
      } else if (hours >= alerta1 && hours < alerta2) {
        data = { icon: 'exclamation-circle-fill', variant: 'estado-yellow' }
      } else if (time >= alerta2) {
        data = { icon: 'exclamation-triangle-fill', variant: 'estado-red' }
      }
      return { ...data, time: formatElapsedTime(time, false) || '---' }
    },
    getActualStateIcon(value) {
      const OT = value.item
      const hora_alerta_1 = OT.estado.estado?.hora_alerta_1 * 3600
      const hora_alerta_2 = OT.estado.estado?.hora_alerta_2 * 3600
      if (hora_alerta_1 > OT.state_time) {
        return 'check-circle'
      }
      if (hora_alerta_1 <= OT.state_time && OT.state_time < hora_alerta_2) {
        return 'exclamation-circle-fill'
      }
      if (OT.state_time >= hora_alerta_2) {
        return 'exclamation-triangle-fill'
      }
      return ''
    },
    getActualStateVariant(value) {
      const OT = value.item
      const hora_alerta_1 = OT.estado.estado?.hora_alerta_1 * 3600
      const hora_alerta_2 = OT.estado.estado?.hora_alerta_2 * 3600
      if (hora_alerta_1 > OT.state_time) {
        return 'success'
      }
      if (hora_alerta_1 <= OT.state_time && OT.state_time < hora_alerta_2) {
        return 'warning'
      }
      if (OT.state_time >= hora_alerta_2) {
        return 'danger'
      }
    },
    showSerialNumberAlertModal(ot) {
      this.serialNumberAlertModal = true
      this.serialNumberAlertOT = ot
    },
    getActions(signal, ot) {
      const data = {
        ot,
        signal,
      }
      return this.getActionsOT(data)
    },
    async onEstadoHovered(item) {
      if (item?.ot?.estado?.estado?.nombre === 'Espera de partes') {
        const otId = item.ot.ot

        if (this.partesData[otId]) {
          return
        }

        try {
          console.log(
            `Hover detectado en estado de OT ${otId} con estado "Espera de partes"`
          )
          const response = await this.getPartesOT(otId)
          console.log(`Partes de la OT ${otId}:`, response.data)

          this.$set(this.partesData, otId, response.data)
        } catch (error) {
          console.error(`Error al obtener partes de la OT ${otId}:`, error)
        }
      }
    },
    getEstadoForRetail(item, value) {
      if (
        this.isRetailUser &&
        item.ot.cambio_3x3 &&
        value &&
        value.estado &&
        value.estado.nombre === 'Reparado'
      ) {
        return {
          ...value,
          estado: { ...value.estado, nombre: 'Autorizado a cambio' },
        }
      }
      return value
    },
    getPartesTooltip(item) {
      if (item?.ot?.estado?.estado?.nombre !== 'Espera de partes') {
        return ''
      }

      const otId = item.ot.ot
      const partes = this.partesData[otId]

      if (
        !partes ||
        !partes.solicitud_partes ||
        partes.solicitud_partes.length === 0
      ) {
        return 'Cargando partes...'
      }

      const partNumbers = partes.solicitud_partes
        .map((solicitud) => {
          const { part_number: partNumber, description } = solicitud.parte
          const { fecha_hora_entrega_estimada } = solicitud

          let fechaFormateada = fecha_hora_entrega_estimada
          if (fecha_hora_entrega_estimada) {
            fechaFormateada = moment(fecha_hora_entrega_estimada).format(
              'DD-MM-YYYY'
            )
          }
          return `<div><strong>${partNumber}</strong><br><small>${description}</small><br><em>Entrega estimada: <br>${fechaFormateada}</em></div>`
        })
        .join('<hr>')

      return `<div style="text-align: left;"><strong>Partes solicitadas:</strong><hr>${partNumbers}</div>`
    },
  },
  beforeDestroy() {
    if (this.controller) this.controller.abort()
  },
  watch: {
    sortBy: {
      immediate: true,
      handler(newVal) {
        if (newVal !== this.internalSortBy) {
          this.internalSortBy = newVal
        }
      },
    },
    sortDesc: {
      immediate: true,
      handler(newVal) {
        if (newVal !== this.internalSortDesc) {
          this.internalSortDesc = newVal
        }
      },
    },
    otItems: {
      immediate: true,
      deep: false,
      async handler(newVal) {
        if (!this.loading && this.firstLoad && newVal.length > 0)
          this.firstLoad = false
        if (
          !newVal ||
          !Array.isArray(newVal.results) ||
          newVal.results.length === 0
        )
          return

        // Cancela una tanda previa si existía
        if (this.controller) this.controller.abort()
        // Nueva tanda con su propio AbortController
        this.controller = new AbortController()
        // const { signal } = this.controller; // no se usa: evitamos warning

        // 1) Usar acciones entregadas por el listado (evita N llamadas)
        // eslint-disable-next-line no-restricted-syntax
        for (const row of this.currentTableItems) {
          const accionesDeLista = row?.ot?.acciones
          // El backend entrega un objeto {visible, disabled, ...}; úsalo tal cual si existe
          const hasAccionesObj =
            accionesDeLista && typeof accionesDeLista === 'object'
          this.$set(
            row,
            'accionesDisponibles',
            hasAccionesObj ? accionesDeLista : undefined
          )
        }

        // 2) SIN fallback automático: si faltan acciones, se obtendrán al abrir el modal (botón)
        // Esto evita N llamadas al montar/cambiar de tab.
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.containe-list {
  /* box-shadow: 0px 3px 6px #00000029; */
  /* border: solid 1px red; */
  min-height: 30vh;
}

.ver-pedido {
  color: #fff;
  background-color: var(--button);
  border-color: var(--button);
  width: 90px;
  height: 40px;
  border-radius: 5px;
  font-weight: 600;

  &:disabled {
    background-color: #7d93ff;
    border-color: #7d93ff;
    cursor: not-allowed;
  }
}

.ot {
  color: #41509b;
  font-weight: bold;
}

.header-tecnico {
  font-size: 1.2em;
  font-weight: 700;
}

::v-deep .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: var(--button);
  font-weight: bold;
}

::v-deep .card-header {
  background-color: #ffffff;
  overflow-x: auto;

  ul {
    overflow-x: visible;
  }

  a {
    color: #495057;
    font-weight: bold;

    &:hover {
      color: #495057;
    }
  }
}

::v-deep table th {
  color: #495057;
}

a.router-link-active {
  color: var(--button);
}

.text-danger {
  color: var(--button) !important;
}

::v-deep .card-body {
  padding: 0;
}

.text-danger[data-v-76755bd8] {
  color: #d32b2b !important;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: var(--button) !important;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.ot-cell {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  @include media-breakpoint-down(sm) {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
}

::v-deep .tabla-tbody td {
  @include media-breakpoint-down(sm) {
    padding: 10px;
  }
}

::v-deep .tabla-thead th {
  @include media-breakpoint-down(sm) {
    padding: 4px 10px 4px;
  }
}

.cursor-pointer {
  cursor: pointer;
}
</style>
